/* Ocean Racing product gallery filter (ntd-gallery.js).
   Shows the gallery images whose alt text starts with the selected Color (up to 5), and for a combined
   color such as "One of each: Black + Tortoise" shows 3 of the first part then the rest from the second.
   Moved verbatim out of layout/theme.liquid on 2026-10-06 (the previous developer's inline script;
   the three console lines were dropped). Loaded with defer on product templates only. */
document.addEventListener('DOMContentLoaded', function () {
  function clean(text) {
    return (text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/\s*\/\s*/g, ' / ')
      .replace(/\s+[0-9]+$/, '')
      .trim();
  }

  function getSelectedColorText() {
    var colorText = '';

    document.querySelectorAll('.product__info-wrapper, .product__info-container, product-info').forEach(function (area) {
      if (colorText) return;

      var text = area.innerText || '';
      var match = text.match(/Color:\s*(.+)/i);

      if (match && match[1]) {
        colorText = match[1].split('\n')[0].trim();
      }
    });

    if (colorText) return clean(colorText);

    var checked = document.querySelector('.product-form__input input[type="radio"]:checked');

    if (checked && checked.value) {
      return clean(checked.value);
    }

    return '';
  }

  function getImageAlt(item) {
    var img = item.querySelector('img');
    if (!img) return '';

    return clean(img.getAttribute('alt'));
  }

  function showItem(item) {
    item.style.setProperty('display', 'block', 'important');
    item.style.setProperty('visibility', 'visible', 'important');
    item.style.setProperty('opacity', '1', 'important');
  }

  function hideItem(item) {
    item.style.setProperty('display', 'none', 'important');
  }

  /* NTD 2026-09-25: a combined color such as "One of each: Black + Tortoise" has no images of its
     own. Split it into its parts and show images whose alt names either part (3 of the first, then
     the rest of the 5 from the second). Single colors are unaffected. */
  function comboParts(selected) {
    if (selected.indexOf('+') === -1) return null;
    var parts = selected.split(':').pop().split('+').map(function (part) {
      return part.trim();
    }).filter(Boolean);
    return parts.length > 1 ? parts : null;
  }

  function filterComboImages(mediaItems, parts) {
    var picked = [];
    parts.forEach(function (part, index) {
      var quota = index === 0 ? 3 : 5 - picked.length;
      mediaItems.forEach(function (item) {
        if (quota > 0 && picked.indexOf(item) === -1 && getImageAlt(item).indexOf(part) !== -1) {
          picked.push(item);
          quota--;
        }
      });
    });
    mediaItems.forEach(function (item) {
      if (picked.indexOf(item) !== -1) {
        showItem(item);
      } else {
        hideItem(item);
      }
    });
    return picked.length;
  }

  function filterProductImages() {
    var selectedColor = getSelectedColorText();
    var mediaItems = Array.from(document.querySelectorAll('.product__media-item')).filter(function (item) {
      return item.querySelector('img');
    });

    /* NTD 10/8/26: when a colour has no alt-matched images (the goggles), show the variant's own image first.
       Dawn already puts the selected variant's media first and drops the other variants' media. */

    var parts = comboParts(selectedColor);
    if (parts && filterComboImages(mediaItems, parts) > 0) return;

    var shown = 0;

    mediaItems.forEach(function (item) {
      var alt = getImageAlt(item);

      if (selectedColor && alt.indexOf(selectedColor) === 0 && shown < 5) {
        showItem(item);
        shown++;
      } else {
        hideItem(item);
      }
    });

    if (shown === 0) {
      mediaItems.forEach(function (item, index) {
        if (index < 5) {
          showItem(item);
        } else {
          hideItem(item);
        }
      });
    }

  }

  filterProductImages();

  document.addEventListener('change', function () {
    setTimeout(filterProductImages, 100);
    setTimeout(filterProductImages, 500);
    setTimeout(filterProductImages, 1000);
  });

  document.addEventListener('click', function () {
    setTimeout(filterProductImages, 100);
    setTimeout(filterProductImages, 500);
    setTimeout(filterProductImages, 1000);
  });

  var productArea = document.querySelector('product-info, .product__info-wrapper, .product');
  if (productArea) {
    var observer = new MutationObserver(function () {
      setTimeout(filterProductImages, 100);
    });

    observer.observe(productArea, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });
  }
});
